import PropTypes from "prop-types";
import React, { PureComponent } from "react";

export default class Box extends PureComponent {
	static propTypes = {		
		title: PropTypes.string.isRequired,
		className: PropTypes.string,
	};

	componentDidMount = () => {		
	}
	
	render() {		
		return (
			<div className={"box " + (this.props.className ? this.props.className : "")}>
				<div className="title">{this.props.title}</div>				
				<div className="content">
					{this.props.children}
				</div>
			</div>							
		);
	}
}
